//
import moment from 'moment'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

//
import NumeroALetras from '@/mixins/NumeroALetras'

//
import CompanyModel from '@/models/General/GCompany'
import SalarySettlementService from '@/services/api/salarySettlement'
/* mixins */
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
/**
 *
 */
export default async id => {
    //
    const { data } = await CompanyModel.get(),
        company = data[0]

    //
    console.log('print salary settlement')
    
    //
    const salarySettlement = await SalarySettlementService.fetchById(id),
        salarySettlementPeriodMonth = salarySettlement.period_month - 1,
        salarySettlementPeriodYear = salarySettlement.period_year,
        salarySettlementPeriodDate = moment()
            .year(salarySettlementPeriodYear)
            .month(salarySettlementPeriodMonth)
            .locale('es'),
        salarySettlementDate =
            salarySettlementPeriodDate
                .format('MMMM')
                .charAt(0)
                .toUpperCase() +
            salarySettlementPeriodDate.format('MMMM YYYY').slice(1),
        salarySettlementEmployee = [
            salarySettlement.hr_employee.names,
            salarySettlement.hr_employee.last_name1,
            salarySettlement.hr_employee.last_name2,
        ].join(' '),
        salarySettlementRut = salarySettlement.hr_employee.rut,
        salarySettlementFamilyAssignment = String(
            salarySettlement.family_assignment
        ),
        salarySettlementWorkedDays = String(salarySettlement.worked_days),
        salarySettlementPrevisionName = salarySettlement.hr_prevision.name,
        salarySettlementExtraHH = String(salarySettlement.extra_hh),
        salarySettlementHealth = String(
            salarySettlement.hr_health_affiliation.name
        ),
        salarySettlementInit = salarySettlement.hr_contract.init_date,
        salarySettlementBaseSalary = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.base_salary_proportional
            )
        ),
        salarySettlementBonuses = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.bonuses
            )
        ),
        salarySettlementCommissions = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.commissions
            )
        ),
        salarySettlementAmountExtraHH = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.amount_extra_hh
            )
        ),
        salarySettlementAmountDiscountHH = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.amount_discount_hh
            )
        ),
        salarySettlementGratification = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.gratification
            )
        ),
        salarySettlementTotalImponible = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.total_imponible
            )
        ),
        salarySettlementPrevisionAmount = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.prevision_amount
            )
        ),
        salarySettlementHealthAmount = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.health_amount
            )
        ),
        salarySettlementUnemploymentInsurance = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.unemployment_insurance
            )
        ),
        salarySettlementTaxAmount = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.unique_tax_amount
            )
        ),
        salarySettlementTotalLegal = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.total_legal
            )
        ),
        salarySettlementCollation = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.hr_contract.collation
            )
        ),
        salarySettlementMobilization = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.hr_contract.mobilization
            )
        ),
        salarySettlementAPV = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.apv
            )
        ),
        salarySettlementAdvance = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.advance
            )
        ),
        salarySettlementTotalNoImponible = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.total_no_imponible
            )
        ),
        salarySettlementTotalHaberes = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.total_haberes
            )
        ),
        salarySettlementTotalPersonal = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.total_personal
            )
        ),
        salarySettlementDiscounts = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.discounts
            )
        ),
        salarySettlementLiquidSalary = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.liquid_salary
            )
        ),
        /*salarySettlementIps = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.ips_amount
            )
        ),*/
        salarySettlementCCAF = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.ccaf_amount
            )
        ),
        salarySettlementMutual = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.mutual_amount
            )
        ),
        salarySettlementAPVAFP = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.apv_afp
            )
        ),
        salarySettlementLoanCCAF = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.loan_ccaf_quote_amount 
            )
        ),
        salarySettlementLoanCompany = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.loan_company_quote_amount
            )
        ),
        salarySettlementInternalCreditAmount = String(
            TextFormatting.filters.mixThousandSeparatorFormat(
                salarySettlement.internal_credit_amount || 0
            )
        ),
        salarySettlementLiquidSalaryString = NumeroALetras(salarySettlement.liquid_salary)
    /*console.log(
        TextFormatting.filters.mixThousandSeparatorFormat(
            parseInt(salarySettlement.total_haberes)
        ),
        'format'
    )*/

    //
    //console.log( NumeroALetras(salarySettlement.liquid_salary) )

    //
    let impArr = [],
        noImpArr = [],
        legArr = [],
        perArr = [],
        topArr = [],
        botArr = []

    //
    salarySettlement.hr_asset_discounts.forEach(assetDiscount => {
        //
        const type = assetDiscount.hr_asset_discount_type_id,
            name = assetDiscount.name,
            amount = assetDiscount.pivot.amount,
            value =
                '$ ' +
                TextFormatting.filters.mixThousandSeparatorFormat(amount),
            item = { name, value }

        //
        switch (type) {
            case 1:
                impArr.push(item)
                break
            case 2:
                noImpArr.push(item)
                break
            case 3:
                legArr.push(item)
                break
            case 4:
                perArr.push(item)
                break
        }
    })

    //
    for (let idx = 0; idx < Math.max(impArr.length, legArr.length); idx++) {
        topArr.push([
            impArr[idx] ? impArr[idx].name : '',
            impArr[idx] ? impArr[idx].value : '',
            legArr[idx] ? legArr[idx].name : '',
            legArr[idx] ? legArr[idx].value : '',
        ])
    }

    //
    for (let jdx = 0; jdx < Math.max(noImpArr.length, perArr.length); jdx++) {
        botArr.push([
            noImpArr[jdx] ? noImpArr[jdx].name : '',
            noImpArr[jdx] ? noImpArr[jdx].value : '',
            perArr[jdx] ? perArr[jdx].name : '',
            perArr[jdx] ? perArr[jdx].value : '',
        ])
    }

    //
    var doc = new jsPDF({ putOnlyUsedFonts: true })

    //
    doc.setFontStyle('bold')
    doc.text('LIQUIDACIÓN DE SUELDO', 16, 20)

    //
    doc.setFontSize(14)
    doc.setTextColor('#087f23')
    doc.text(salarySettlementDate, 16, 26)

    //
    doc.setFontSize(10)
    doc.setFontStyle('normal')
    doc.setTextColor('#000')

    //
    doc.setFontStyle('normal').text('EMPLEADOR:', 16, 35)
    doc.setFontStyle('bold').text(company.business_name, 42, 35)
    //
    doc.setFontStyle('normal').text('RUT:', 16, 40)
    doc.setFontStyle('bold').text(company.rut, 42, 40)
    //
    doc.setFontStyle('normal').text('DIRECCIÓN:', 16, 45)
    doc.setFontStyle('bold').text(company.address, 42, 45)

    //
    //doc.text( 'CÓDIGO DE CLIENTE:', 200, 50 )
    //doc.setFontStyle( 'bold' )
    //doc.text( paymentVerifyRut, 247, 50 )
    //doc.setFontStyle( 'normal' )

    //
    doc.setFontStyle('normal').text('EMPLEADO:', 16, 55)
    doc.setFontStyle('bold').text(salarySettlementEmployee, 42, 55)
    //
    doc.setFontStyle('normal').text('FECHA DE INGRESO:', 120, 55)
    doc.setFontStyle('bold').text(
        moment(salarySettlementInit).format('D/M/YYYY'),
        160,
        55
    )
    //
    doc.setFontStyle('normal').text('RUT:', 16, 60)
    doc.setFontStyle('bold').text(salarySettlementRut, 42, 60)
    //
    doc.setFontStyle('normal').text('CARGAS:', 120, 60)
    doc.setFontStyle('bold').text(salarySettlementFamilyAssignment, 160, 60)
    //
    doc.setFontStyle('normal').text('CARGO:', 16, 65)
    doc.setFontStyle('bold').text('', 42, 65)
    //
    doc.setFontStyle('normal').text('DIAS TRABAJADOS:', 120, 65)
    doc.setFontStyle('bold').text(salarySettlementWorkedDays, 160, 65)
    //
    doc.setFontStyle('normal').text('AFP:', 16, 70)
    doc.setFontStyle('bold').text(salarySettlementPrevisionName, 42, 70)
    //
    doc.setFontStyle('normal').text('HORAS EXTRAS:', 120, 70)
    doc.setFontStyle('bold').text(salarySettlementExtraHH, 160, 70)
    //
    doc.setFontStyle('normal').text('ISAPRE:', 16, 75)
    doc.setFontStyle('bold').text(salarySettlementHealth, 42, 75)

    //
    //doc.text( 'EFECTIVO $', 16, 58 )
    //doc.setFontStyle( 'bold' )
    //doc.text( paymentVerifyAmount, 44, 58 )
    //doc.setFontStyle( 'normal' )
    
    //
    var imponibleArr = [
        {
            text: 'Sueldo Base',
            value: salarySettlementBaseSalary,
        },
        {
            text: 'Bonos',
            value: salarySettlementBonuses,
        },
        {
            text: 'Comisiones',
            value: salarySettlementCommissions,
        },
        {
            text: 'Horas Extra',
            value: salarySettlementAmountExtraHH,
        },
        {
            text: 'Horas Descuento',
            value: salarySettlementAmountDiscountHH,
        },
        {
            text: 'Gratificacion Legal',
            value: salarySettlementGratification,
        },
    ]

    //
    var descuentosLegalesArr = [
        {
            text: 'Cotización AFP',
            value: salarySettlementPrevisionAmount,
        },
        {
            text: 'Cotización Salud',
            value: salarySettlementHealthAmount,
        },
        {
            text: 'Seguro de Cesantía',
            value: salarySettlementUnemploymentInsurance,
        },
        {
            text: 'Impuesto Único',
            value: salarySettlementTaxAmount,
        },
        /*{
            text: 'IPS',
            value: salarySettlementIps,
        },*/
    ]

    //
    var upLeftArr = imponibleArr.filter( item=> item.value != 0 )
    var upRightArr = descuentosLegalesArr.filter( item=> item.value != 0 )
    var upArr = []

    //
    for (var i = 0; i < upLeftArr.length || i < upRightArr.length; i++) {
        upArr.push([
            upLeftArr[i] ? upLeftArr[i].text : '',
            upLeftArr[i] ? '$ ' + upLeftArr[i].value : '',
            upRightArr[i] ? upRightArr[i].text : '',
            upRightArr[i] ? '$ ' + upRightArr[i].value : '',
        ])
    }

    //
    doc.autoTable({
        head: [
            [
                { colSpan: 2, content: 'HABERES' },
                { colSpan: 2, content: 'DESCUENTOS' },
            ],
            [
                { colSpan: 2, content: 'IMPONIBLES' },
                { colSpan: 2, content: 'DESCUENTOS LEGALES' },
            ],
        ],
        columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 25, halign: 'right' },
            2: { cellWidth: 25 },
            3: { cellWidth: 25, halign: 'right' },
        },
        headStyles: {
            fillColor: '#2196F3',
            fontSize: 10,
            fontStyle: 'bold',
            lineColor: '#2196F3',
            lineWidth: 0,
            textColor: '#fafafa',
        },
        body: [
            ...upArr,
            ...topArr,
            [
                'Total Imponible',
                '$ ' + salarySettlementTotalImponible,
                'Total descuentos legales',
                '$ ' + salarySettlementTotalLegal,
            ],
        ],
        bodyStyles: {
            fontSize: 10,
            textColor: '#000',
        },
        theme: 'grid',
        startY: 85,
    })

    //
    var noImponibleArr = [
        {
            text: 'Colacion',
            value: salarySettlementCollation,
        },
        {
            text: 'Movilización',
            value: salarySettlementMobilization,
        },
        {
            text: 'Asignación Familiar',
            value: salarySettlementFamilyAssignment,
        },
    ]

    //
    var descuentosPersonalesArr = [
        {
            text: 'Ahorro previsional voluntario',
            value: salarySettlementAPV,
        },
        {
            text: 'Avance o Anticipo',
            value: salarySettlementAdvance,
        },
        {
            text: 'Cuenta 2 AFP',
            value: salarySettlementAPVAFP,
        },
        {
            text: 'Descuento CCAF',
            value: salarySettlementLoanCCAF,
        },
        {
            text: 'Descuento por planilla',
            value: salarySettlementInternalCreditAmount,
        },
        {
            text: 'Prestamo Empresa',
            value: salarySettlementLoanCompany,
        },
    ]

    //
    var downLeftArr = noImponibleArr.filter( item => item.value != 0 )
    var downRightArr = descuentosPersonalesArr.filter( item => item.value != 0 )
    var downArr = []

    //
    for (var i = 0; i < downLeftArr.length || i < downRightArr.length; i++) {
        downArr.push([
            downLeftArr[i] ? downLeftArr[i].text : '',
            downLeftArr[i] ? '$ ' + downLeftArr[i].value : '',
            downRightArr[i] ? downRightArr[i].text : '',
            downRightArr[i] ? '$ ' + downRightArr[i].value : '',
        ])
    }

    //
    doc.autoTable({
        head: [
            [
                { colSpan: 2, content: 'NO IMPONIBLES' },
                { colSpan: 2, content: 'DESCUENTOS PERSONALES' },
            ],
        ],
        columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 25, halign: 'right' },
            2: { cellWidth: 25 },
            3: { cellWidth: 25, halign: 'right' },
        },
        headStyles: {
            fillColor: '#2196F3',
            fontSize: 10,
            fontStyle: 'bold',
            lineColor: '#2196F3',
            lineWidth: 0,
            textColor: '#fafafa',
        },
        body: [
            ...downArr,
            ...botArr,
            [
                'Total no imponible',
                '$ ' + salarySettlementTotalNoImponible,
                'Total descuentos personales',
                '$ ' + salarySettlementTotalPersonal,
            ],
            [
                'Total haberes',
                '$ ' + salarySettlementTotalHaberes,
                'Total descuentos',
                '$ ' + salarySettlementDiscounts,
            ],
            [
                {
                    content: 'Sueldo liquido',
                    styles: {
                        fontStyle: 'bold',
                    },
                },
                {
                    content: '$ ' + salarySettlementLiquidSalary,
                    styles: {
                        fontStyle: 'bold',
                    },
                },
                '',
                '',
            ],
        ],
        bodyStyles: {
            fontSize: 10,
            textColor: '#000',
        },
        theme: 'grid',
        startY: 85 + ( (upArr.length + topArr.length + 3) * 7.625),
    })

    var legendY = 168 + (topArr.length * 7.625) + 170 + (botArr.length * 7.625)

    doc.setFontStyle('normal').text('SON: ' + salarySettlementLiquidSalaryString, 16, legendY)

    //
    doc
        .setFontSize(8)
        .text('SON: ' + salarySettlementLiquidSalaryString + ' PESOS.', 16, 257)

    //
    doc
        .setFontStyle('normal')
        .setFontSize(6)
        .text('RECIBI CONFORME EL ALCANCE LIQUIDO DE LA PRESENTE LIQUIDACIÓN, NO TENIENDO CARGO O COBRO ALGUNO QUE HACER POR NINGUN CONCEPTO..', 16, 260)

    //
    doc        
        .setFontSize(8)
        .setFontStyle('bold')
        .text('FIRMA EMPLEADOR', 32, 285)
        .text('FIRMA TRABAJADOR', 150, 285)

    //
    doc
        .save(['liquidación-sueldo-' + id + '.pdf'].join(''))
}
